import { Paper } from "@material-ui/core";
import { Group, Event, Description } from "@material-ui/icons";
import DynamicFeedRoundedIcon from "@mui/icons-material/DynamicFeedRounded";
import "../../../../Assets/css/Community/MyfeedInfo.css";
import { useNavigate } from "react-router-dom";
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';
import { useSelector } from "react-redux";

const MyfeedInfo = () => {
  const navigate = useNavigate();
  const events = useSelector((state) => state?.community?.events);

  const hasVolunteerEvents = events.some(event => event?.is_volunteer === true);

  const handleTabNavigation = (tabKey) => {
    navigate(`/my-feeds?tab=${tabKey}`);
  };

  return (
    <div className="myfeed-info-container">
      <Paper className="myfeed-container">
        <div
          className="myfeed-section"
          onClick={() => handleTabNavigation("second")}
        >
          <DynamicFeedRoundedIcon className="myfeed-icon" />
          <span>My Posts</span>
        </div>
        {/* <div
          className="myfeed-section"
          onClick={() => handleTabNavigation("third")}
        >
          <Group className="myfeed-icon" />
          <span>My Communities</span>
        </div> */}
        <div
          className="myfeed-section"
          onClick={() => handleTabNavigation("fourth")}
        >
          <Event className="myfeed-icon" />
          <span>My Events</span>
        </div>
        {/* <div
          className="myfeed-section"
          onClick={() => handleTabNavigation("fifth")}
        >
          <Description className="myfeed-icon" />
          <span>My Blogs</span>
        </div> */}
        <div
          className="myfeed-section"
          onClick={() => handleTabNavigation("sixth")}
        >
          <ConfirmationNumberOutlinedIcon className="myfeed-icon" />
          <span>Booked Events</span>
        </div>
       {hasVolunteerEvents && <div
          className="myfeed-section"
          onClick={() => handleTabNavigation("seventh")}
        >
          <VolunteerActivismOutlinedIcon className="myfeed-icon" />
          <span>Assigned Events</span>
        </div>}
      </Paper>
    </div>
  );
};

export default MyfeedInfo;
